import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Roles } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { ISolicitudDerivarModel } from 'src/app/models/interfaces/solicitud/ISolicitudDerivarModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';

@Component({
  selector: 'app-solicitud-derivar-dialog',
  templateUrl: './solicitud-derivar-dialog.component.html',
  styleUrls: ['./solicitud-derivar-dialog.component.css']
})
export class SolicitudDerivarDialogComponent implements OnInit {
  listaRevisores: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();

  constructor(
    public dialogRef: MatDialogRef<SolicitudDerivarDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISolicitudDerivarModel,
    private usuarioService: SeguridadUsuarioService,
    private solicitudService: SolicitudService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {

    let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
        filterUsuario.idRol = Roles.REVISOR;
        filterUsuario.idSede = this.data.idSede;
      
        this.usuarioService
          .getList(filterUsuario)
          .subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
            this.listaRevisores = data.items;
          });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enviar(){ 
    
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {     
      this.solicitudService.derivar(this.data).subscribe((p) => {
        this.alertDialogService.open('La solicitud fue DERIVADA.');
        this.dialogRef.close();
      });
    }
  }
}
